<template>
  <div class="wrapper health">
    <div class="caption">{{caption}}</div>
    <div class="filter" v-if="step < 3">
      <a-input ref="filter" clearable label="Filter" v-model="filter" />
    </div>
    <div class="options">
      <template v-if="step === 1">
        <div :class="{'hidden': conditionCategory.hide, 'pre-selected': preSelection && preSelection.conditionCategory.id === conditionCategory.id}"
             v-for="conditionCategory in conditionCategories"
             :key="conditionCategory.id"
             @click="addConditionCategory(conditionCategory); pushDataLayer('tierdaten', 'addConditionCategory', conditionCategory.name, false, leadin)">
          <span>{{conditionCategory.name}}</span><br>
          <span v-if="conditionCategory.description" class="filter-sub">{{conditionCategory.description}}</span>
        </div>
      </template>
      <template v-else-if="step === 2">
        <div :class="{'hidden': preCondition.hide, 'pre-selected': preSelection && preSelection.preCondition.id === preCondition.id}"
             v-for="preCondition in selected.conditionCategory.pre_conditions"
             :key="preCondition.id"
             @click="addPreCondition(preCondition); pushDataLayer('tierdaten', 'addPreCondition', preCondition.name, false, leadin)">
          <span>{{preCondition.name}}</span><br>
        </div>
      </template>
    </div>
    <div v-if="step === 3">
      <template v-if="selected.preCondition.name === 'sonstiges'">
        <a-input required type="multiline" v-model="selected.description" :no-label="true"
                 placeholder="Tragen Sie hier bitte den Namen der Krankheit ein, an der das Tier leidet."
                 @blur="pushDataLayer('tierdaten', 'addPreConditionDescription', selected.description, false, leadin)" />
        <div class="caption mt">Wie ist der Status der Behandlung?</div>
      </template>
      <a-checkbox radio v-model="selected.status" label="in laufender Behandlung" value="0" :size="16"
                  v-on:check="pushDataLayer('tierdaten', 'addTreatmentStatus', 'in laufender Behandlung', false, leadin)"/>
      <a-checkbox radio v-model="selected.status" label="Behandlung abgeschlossen" value="1" :size="16"
                  v-on:check="pushDataLayer('tierdaten', 'addTreatmentStatus', 'Behandlung abgeschlossen', false, leadin)"/>
      <div class="caption mt">Wie oft trat die Beschwerde auf?</div>
      <a-checkbox radio v-model="selected.occurrence" label="einmalig" value="0" :size="16"
                  v-on:check="pushDataLayer('tierdaten', 'addTreatmentOccurrence', 'einmalig', false, leadin)"/>
      <a-checkbox radio v-model="selected.occurrence" label="wiederkehrend" value="1" :size="16"
                  v-on:check="pushDataLayer('tierdaten', 'addTreatmentOccurrence', 'wiederkehrend', false, leadin)"/>
      <a-checkbox radio v-model="selected.occurrence" label="dauerhaft (chronisch)" value="2" :size="16"
                  v-on:check="pushDataLayer('tierdaten', 'addTreatmentOccurrence', 'dauerhaft (chronisch)', false, leadin)"/>
      <a-btn-set>
        <a-btn @click="saveTreatment()" :disabled="!selected.occurrence || !selected.status || (selected.preCondition.name === 'sonstiges' && selected.description === '')">
          Speichern
        </a-btn>
      </a-btn-set>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    conditionCategories: {
      type: Array,
      default: () => []
    },
    preSelection: {
      type: Object,
      default() {
        return {}
      }
    },
    registry: {
      type: Object,
      default() {
        return {}
      }
    },
    leadin: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data: () => ({
    caption: 'In welchem Bereich lag die Erkrankung vor?',
    filter: '',
    filterableOptions: [],
    step: 1,
    selected: {
      conditionCategory: null,
      preCondition: null,
      description: '',
      status: null,
      occurrence: null
    }
  }),
  watch: {
    conditionCategories: {
      immediate: true,
      handler (to) {
        this.filterableOptions = Array.from(to)
      }
    },
    filter: {
      immediate: true,
      handler (to) {
        if (this.step === 1) {
          this.filterableOptions.forEach(conditionCategory => {
            const condition = conditionCategory.pre_conditions.map(pk => pk.name).join(' ');
            const searchString = `${conditionCategory.name} ${conditionCategory.description} ${condition}`.toLowerCase();
            conditionCategory.hide = !searchString.includes(to.toLowerCase());
          });
        } else if (this.step === 2) {
          this.filterableOptions.find(res => res.name === this.selected.conditionCategory.name).pre_conditions.forEach(preCondition => {
            preCondition.hide = String(preCondition.name).toLowerCase().indexOf(String(to).toLowerCase()) < 0
          })
        }
      }
    }
  },
  methods: {
    saveTreatment () {
      if (this.selected.preCondition.name !== 'sonstiges') {
        this.selected.description = '';
      }
      this.$emit('done', this.selected);
    },
    addConditionCategory(conditionCategory) {
      this.step = 2;
      this.caption = 'Was wurde behandelt?'
      this.selected.conditionCategory = conditionCategory;
      this.setFilterFocus();
    },
    addPreCondition(preCondition) {
      this.step = 3;
      this.caption = preCondition.name === 'sonstiges' ? 'Was wurde behandelt?' : 'Wie ist der Status der Behandlung?';
      this.selected.preCondition = preCondition;
      if (this.preSelection && (this.selected.preCondition.id !== this.preSelection.preCondition.id || this.selected.conditionCategory.id !== this.preSelection.conditionCategory.id)) {
        this.selected.status = null;
        this.selected.occurrence = null;
      }
    },
    setFilterFocus() {
      this.filter = '';
      if (window &&
          window.innerWidth &&
          window.innerWidth > 544) {
        this.$nextTick(() => {
          if (this.$refs.filter) {
            this.$refs.filter.labelAction()
          }
        })
      }
    }
  },
  mounted () {
    this.setFilterFocus();
    if (this.preSelection) {
      this.selected = JSON.parse(JSON.stringify(this.preSelection));
    }
  }
}

</script>

<style lang="scss">

.wrapper.health {
  .caption {
    margin-bottom: 20px;
    font-weight: bold;
    color: #014e9e;
    &.mt {
      margin-top: 35px;
    }
  }

  .options {
    max-height: 50vh;
    @media (min-width: 800px) {
      max-height: 60vh;
    }

    .pre-selected {
      background-color: #f6faff;
    }
  }

  min-height: 335px;
  position: relative;

  .checkbox.control.type-radio {
    padding: 5px 0;
  }

  .input-control.type-multiline .wrapper .input {
    padding-top: 0;
  }

  .filter {
    margin-bottom: 20px;
  }

  .filter-sub {
    font-size: 12px;
  }

  .options {
    overflow: auto;
    margin: 0 -20px;
    background-color: #eee;

    div {
      cursor: pointer;
      font-size: 16px;
      padding: 10px 20px;
      background-color: #fff;
      margin: 1px 0;

      &:hover {
        background-color: transparent;
      }

      &.hidden {
        display: none;
      }
    }
  }

  .input-control.type-multiline {
    font-size: 12px;
  }

  .input-control.type-multiline .label {
    top: 5px;
    left: 0px;
    font-size: 12px;
    margin-left: 10px;
  }

  .input-control.type-multiline .input textarea {
    height: 100px !important;
    font-size: 12px !important;
    padding-top: 15px !important;
    line-height: 15px !important;
  }

  .input-control.type-multiline {
    font-size: 14px !important;
    color: #3b3b3b;
  }

  .input-control.type-multiline + .type-pattern{
    margin-top:20px !important;
  }
  .input-control .control.type-pattern {
    width:46%;
    margin-left:20px;
  }
}

</style>
